var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"app-full-height"},[_c('v-card-title',{staticClass:"d-flex align-start"},[_c('div',{staticClass:"display-3"},[_vm._v("Календарь аренды")])]),_c('v-card-text',{class:_vm.$style.text},[_c('PersonalCalendar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }